import { ReactNode } from "react"
import { SquidStyleProvider, Style } from "@inkblot-therapy/squid"
import { HelmetProvider } from "react-helmet-async"
import { SectionContextProvider } from "../../context/SectionContextProvider"
import { ToastContextProvider } from "../../context/ToastContextProvider"
import { ReactQueryProvider } from "./ReactQueryProvider"
import { ReactRouterProvider } from "./ReactRouterProvider"
import { Auth0ProviderWithRedirectCallback } from "./Auth0ProviderWithRedirectCallback"

interface Props {
  children: ReactNode
}

export function Providers({ children }: Props) {
  return (
    <ReactRouterProvider>
      <Auth0ProviderWithRedirectCallback>
        <SquidStyleProvider selector={".my-squid"}>
          <Style />
          <SectionContextProvider>
            <ToastContextProvider>
              <HelmetProvider>
                <ReactQueryProvider>{children}</ReactQueryProvider>
              </HelmetProvider>
            </ToastContextProvider>
          </SectionContextProvider>
        </SquidStyleProvider>
      </Auth0ProviderWithRedirectCallback>
    </ReactRouterProvider>
  )
}
